@if (options && on4sig) {
  <div
    class="leaflet"
    leaflet
    leafletDraw
    [leafletDrawOptions]="drawOptions"
    (leafletDrawCreated)="onDrawCreated($event)"
    (leafletDrawReady)="onDrawReady($event)"
    [leafletOptions]="options()"
    (leafletMapReady)="onMapReady($event)"
    (leafletMouseMove)="leafletMouseMove($event)"
    leafletMeasurePath>
    <div class="visorgis-panel-actions">
      <div class="visorgis-search-and-filters">
        <app-buscador-autocomplete
          class="map-search"
          [formControl]="searchTerm"
          (selectedItem)="showElement($event)"
          [data]="filteredSearchTotal"></app-buscador-autocomplete>
        <div class="filtros-rapidos">
          <app-filtros-rapidos
            [width]="currentWidth() - 95"></app-filtros-rapidos>
        </div>
      </div>
    </div>
    @if (showParcelas) {
      <div
        [leafletLayer]="layers.parcela"
        (leafletLayerAdd)="addedParcelas()"></div>
    }
    @if (showParcelasComunero) {
      <div [leafletLayer]="layers.parcela_comunero"></div>
    }
    @if (showHidrantes) {
      @if (filtroActivos) {
        <div [leafletLayer]="layers.hidrante.active"></div>
      }
      @if (filtroInactivos) {
        <div [leafletLayer]="layers.hidrante.inactive"></div>
      }
      @if (filtroSinContador) {
        <div [leafletLayer]="layers.hidrante.without_counter"></div>
      }
    }
    @if (showPozos) {
      @if (filtroActivos) {
        <div [leafletLayer]="layers.pozo.active"></div>
      }
      @if (filtroInactivos) {
        <div [leafletLayer]="layers.pozo.inactive"></div>
      }
      @if (filtroSinContador) {
        <div [leafletLayer]="layers.pozo.without_counter"></div>
      }
    }
    @if (showCabezales) {
      @if (filtroActivos) {
        <div [leafletLayer]="layers.cabezal.active"></div>
      }
      @if (filtroInactivos) {
        <div [leafletLayer]="layers.cabezal.inactive"></div>
      }
      @if (filtroSinContador) {
        <div [leafletLayer]="layers.cabezal.without_counter"></div>
      }
    }
    @if (showTomas) {
      @if (filtroActivos) {
        <div [leafletLayer]="layers.toma.active"></div>
      }
      @if (filtroInactivos) {
        <div [leafletLayer]="layers.toma.inactive"></div>
      }
      @if (filtroSinContador) {
        <div [leafletLayer]="layers.toma.without_counter"></div>
      }
    }
    @if (showBalsas) {
      @if (filtroActivos) {
        <div [leafletLayer]="layers.balsa.active"></div>
      }
      @if (filtroInactivos) {
        <div [leafletLayer]="layers.balsa.inactive"></div>
      }
      @if (filtroSinContador) {
        <div [leafletLayer]="layers.balsa.without_counter"></div>
      }
    }
    @if (showTuberias) {
      <div [leafletLayer]="layers.tuberia"></div>
    }
    @if (showEstaciones && !anyRiegoFilterActive()) {
      @if (filtroActivos) {
        <div [leafletLayer]="layers.estaciones.active"></div>
      }
      @if (filtroInactivos) {
        <div [leafletLayer]="layers.estaciones.inactive"></div>
      }
    }
    @if (showDispositivosEnergia && !anyRiegoFilterActive()) {
      @if (filtroActivos) {
        <div [leafletLayer]="layers.dispositivos_energia.active"></div>
      }
      @if (filtroInactivos) {
        <div [leafletLayer]="layers.dispositivos_energia.inactive"></div>
      }
    }
    @if (showAnalizadoresRed && !anyRiegoFilterActive()) {
      @if (filtroActivos) {
        <div [leafletLayer]="layers.analizadores_red.active"></div>
      }
      @if (filtroInactivos) {
        <div [leafletLayer]="layers.analizadores_red.inactive"></div>
      }
    }
    @if (showParcelasXhidrante) {
      <div [leafletLayer]="lyrParcelasXhidrante"></div>
    }
    @if (showOtherNetworkElements && !anyRiegoFilterActive()) {
      @if (filtroActivos) {
        <div [leafletLayer]="layers.other_network_elements.active"></div>
      }
      @if (filtroInactivos) {
        <div [leafletLayer]="layers.other_network_elements.inactive"></div>
      }
      @if (filtroSinContador) {
        <div
          [leafletLayer]="layers.other_network_elements.without_counter"></div>
      }
    }
    @if (showOtherHydraulic && !anyRiegoFilterActive()) {
      @if (filtroActivos) {
        <div [leafletLayer]="layers.other_hydraulic.active"></div>
      }
      @if (filtroInactivos) {
        <div [leafletLayer]="layers.other_hydraulic.inactive"></div>
      }
      @if (filtroSinContador) {
        <div [leafletLayer]="layers.other_hydraulic.without_counter"></div>
      }
    }
    @if (showOtherElectricFacilities && !anyRiegoFilterActive()) {
      @if (filtroActivos) {
        <div [leafletLayer]="layers.other_energy_facilities.active"></div>
      }
      @if (filtroInactivos) {
        <div [leafletLayer]="layers.other_energy_facilities.inactive"></div>
      }
      @if (filtroSinContador) {
        <div
          [leafletLayer]="layers.other_energy_facilities.without_counter"></div>
      }
    }
    <div [leafletLayer]="drawnItems"></div>
    <div class="center-bottom">
      @if (showBottomMessage) {
        <div id="bottomMessage" class="gis-bottom-message">
          @if (showBottomMessageIcon) {
            <span class="material-symbols-rounded">cancel</span>
          }
          <span class="textos-body-medium error-bottom-message">{{
            bottomMessage
          }}</span>
        </div>
      }
      <div class="gps-indicator-container">
        <app-gps-indicator
          [latitude]="lat"
          [longitude]="long"></app-gps-indicator>
      </div>
    </div>
  </div>
}

@if (objState2 && cultivos) {
  <div class="cultivos-card">
    <mat-card>
      <mat-card-header>
        <mat-card-title class="textos-title-small">Cultivos</mat-card-title>
      </mat-card-header>
      <mat-card-content class="textos-body-medium">
        @for (tipo of cultivos; track tipo) {
          <span>
            <span
              class="cultivo-legend-item"
              [ngStyle]="{ 'background-color': tipo.color }"></span>
            {{ tipo.nombre }} <br />
          </span>
        }
      </mat-card-content>
    </mat-card>
  </div>
}
